module.exports = __webpack_public_path__ + "media/images/web/home/index/kind_of_events-bc436c59c457d4c589001aab2a436b32.jpg";